import { authorNote, consultationSection, disclaimer } from "@/data/bookContent";
import { motion } from "framer-motion";
import { MessageCircle, Quote } from "lucide-react";

export function ClosingSection() {
  return (
    <motion.div
      style={{ paddingTop: "3rem", paddingBottom: "4rem" }}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div style={{ marginBottom: "3rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.5rem" }}>
          <div style={{ width: "0.25rem", height: "2rem", background: "oklch(0.65 0.12 50)", borderRadius: "9999px" }} />
          <h2 style={{ fontFamily: "'Noto Serif JP', serif", fontSize: "1.5rem", fontWeight: 700, color: "oklch(0.18 0.02 240)" }}>
            著者からの一言
          </h2>
        </div>

        <div
          style={{
            borderRadius: "1rem",
            border: "1px solid oklch(0.88 0.01 240)",
            background: "oklch(0.99 0.005 60)",
            padding: "2rem",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 4px 24px -6px rgba(0,0,0,0.10)"
          }}
        >
          <Quote style={{ position: "absolute", top: "1rem", right: "1.5rem", width: "4rem", height: "4rem", color: "oklch(0.48 0.02 240 / 0.1)" }} />

          <div style={{ display: "flex", flexDirection: "column", gap: "1rem", position: "relative", zIndex: 10 }}>
            {authorNote.map((para, i) => (
              <p
                key={i}
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  lineHeight: 1.9,
                  color: i === authorNote.length - 1 ? "oklch(0.18 0.02 240)" : "oklch(0.18 0.02 240 / 0.85)",
                  fontWeight: i === authorNote.length - 1 ? 600 : 400
                }}
              >
                {para}
              </p>
            ))}
          </div>

          <div style={{ marginTop: "1.5rem", paddingTop: "1.25rem", borderTop: "1px solid oklch(0.88 0.01 240)", display: "flex", alignItems: "center", gap: "0.75rem" }}>
            <div style={{ width: "2.5rem", height: "2.5rem", borderRadius: "9999px", background: "oklch(0.28 0.08 240 / 0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <span style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 700, color: "oklch(0.28 0.08 240)", fontSize: "0.875rem" }}>橋</span>
            </div>
            <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "0.875rem", fontWeight: 600, color: "oklch(0.18 0.02 240)" }}>
              橋本 裕介 / 株式会社TESキャピタル 代表取締役
            </p>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "3rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.5rem" }}>
          <div style={{ width: "0.25rem", height: "2rem", background: "oklch(0.65 0.12 50)", borderRadius: "9999px" }} />
          <h2 style={{ fontFamily: "'Noto Serif JP', serif", fontSize: "1.5rem", fontWeight: 700, color: "oklch(0.18 0.02 240)" }}>
            {consultationSection.title}
          </h2>
        </div>

        <div
          style={{
            borderRadius: "1rem",
            border: "1px solid oklch(0.88 0.01 240)",
            background: "oklch(0.99 0.005 60)",
            padding: "2rem",
            marginBottom: "1.5rem",
            boxShadow: "0 4px 24px -6px rgba(0,0,0,0.10)"
          }}
        >
          <p style={{ fontFamily: "'Noto Sans JP', sans-serif", lineHeight: 1.9, color: "oklch(0.18 0.02 240 / 0.85)" }}>
            {consultationSection.body}
          </p>
        </div>

        <a
          href={consultationSection.lineUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", display: "block" }}
        >
          <div
            style={{
              borderRadius: "1rem",
              padding: "2rem",
              textAlign: "center",
              background: "linear-gradient(135deg, #06c755 0%, #04a546 100%)",
              boxShadow: "0 8px 32px -8px rgba(6,199,85,0.45)",
              cursor: "pointer",
              transition: "transform 0.2s ease, box-shadow 0.2s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 12px 40px -8px rgba(6,199,85,0.55)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 8px 32px -8px rgba(6,199,85,0.45)";
            }}
          >
            <MessageCircle style={{ width: "2.5rem", height: "2.5rem", color: "#ffffff", margin: "0 auto 1rem" }} />
            <h3 style={{ fontFamily: "'Noto Serif JP', serif", fontSize: "1.25rem", fontWeight: 700, color: "#ffffff", marginBottom: "0.5rem" }}>
              住宅購入のご相談はLINEから
            </h3>
            <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "0.875rem", color: "rgba(255,255,255,0.8)", marginBottom: "1.5rem", lineHeight: 1.6 }}>
              お気軽にご相談ください。<br />
              橋本 裕介（株式会社TESキャピタル 代表取締役）が直接対応します。
            </p>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                background: "#ffffff",
                fontFamily: "'Noto Sans JP', sans-serif",
                fontWeight: 700,
                fontSize: "0.875rem",
                padding: "0.75rem 2rem",
                borderRadius: "9999px",
                color: "#15803d",
                boxShadow: "0 4px 12px -2px rgba(0,0,0,0.15)"
              }}
            >
              <MessageCircle style={{ width: "1rem", height: "1rem" }} />
              LINEで相談する
            </div>
          </div>
        </a>
      </div>

      <div style={{ borderRadius: "0.75rem", border: "1px solid oklch(0.88 0.01 240)", background: "oklch(0.94 0.01 60 / 0.3)", padding: "1.5rem" }}>
        <h3 style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "0.875rem", fontWeight: 600, color: "oklch(0.18 0.02 240)", marginBottom: "0.75rem" }}>
          免責・情報基準日
        </h3>
        <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "0.75rem", lineHeight: 1.6, color: "oklch(0.48 0.02 240)" }}>
          {disclaimer}
        </p>
      </div>

      <div style={{ marginTop: "3rem", paddingTop: "1.5rem", borderTop: "1px solid oklch(0.88 0.01 240)", textAlign: "center" }}>
        <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "0.75rem", color: "oklch(0.48 0.02 240)" }}>
          © 2026 橋本 裕介 / 株式会社TESキャピタル
        </p>
      </div>
    </motion.div>
  );
}